import axiosInstance from "../server/axios";



export const fetchVentes = (search, limit, page) => {
    return axiosInstance.get(`/ventes`, {
        params: { search, limit, page },
        headers: {
            'Content-Type': 'application/json',
        },
    });
}; 

export const updateVenteEtat =  (venteId, data) => {

    // console.log(data);
    // return
    
    const token = localStorage.getItem('authToken');
    
    return axiosInstance.put(`/ventes/${venteId}/etat`, data, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
}
    
   

  
